// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".en-linea[data-v-0cb857de] {\n  display: inline-block !important;\n}[dir] .en-linea[data-v-0cb857de] {\n  cursor: pointer;\n}[dir=ltr] .en-linea[data-v-0cb857de] {\n  margin-left: 3px !important;\n}[dir=rtl] .en-linea[data-v-0cb857de] {\n  margin-right: 3px !important;\n}\n", ""]);
// Exports
module.exports = exports;
